import { AppEnvironment } from '@ca/environment/app-environment.enum';
import { environment } from '@ca/environment/environment';
import { datadogRum } from '@datadog/browser-rum';

export function loadExternalScripts(): void {
    // TODO Temporary fix (!window.location.host.startsWith('pr-')) to avoid loading production scripts in pr envs.
    // Remove when build in pipeline is fixed to run a build with --pr parameter and when properties in environment.pr are correctly set.
    // Check the https://dev.azure.com/ZEISSgroup/MIC_Capta_Astra/_boards/board/t/Dev/Stories/?workitem=582863 user story.
    if (environment.type === AppEnvironment.Production && !window.location.host.startsWith('pr-')) {
        // Google Tag Manager
        const tagManagerScriptText = `
window.dataLayer = [{ pagePool: 'mic', pageIdentifier: 'apeer', pageCountry: 'int', pageArea: 'spa', pageLanguage: 'en' }];
(function (w, d, s, l, i) {
w[l] = w[l] || [];
w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
const f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l !== 'dataLayer' ? '&l=' + l : '';
j.async = true;
// un-comment to stop using analytics proxy
j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-T9TL3VX');
    `;
        loadScriptToHead(tagManagerScriptText);

        // Marketo's Munchkin tracking
        const munchkinText = `
(function () {
    let didInit = false;
    function initMunchkin() {
        if (didInit === false) {
            didInit = true;
            Munchkin.init('896-XMS-794', { wsInfo: 'j0pXbMXJIw%3D%3D' });
        }
    }
    const s = document.createElement('script');
    s.type = 'text/javascript';
    s.async = true;
    s.src = '//munchkin.marketo.net/munchkin.js';
    s.onreadystatechange = function () {
        if (this.readyState === 'complete' || this.readyState === 'loaded') {
            initMunchkin();
        }
    };
    s.onload = initMunchkin;
    document.getElementsByTagName('head')[0].appendChild(s);
})();
    `;
        loadScriptToHead(munchkinText);
    }

    if (environment.type === AppEnvironment.Production || environment.type === AppEnvironment.Feature7) {
        // Inline manual
        const url = 'https://inlinemanual.com/embed/player.ff03f120c1c11e3480a015b1e5021a12.bare.js';
        loadScriptSrcAppendToBody(url);
    }
    addDatadog();
}

export function loadScriptSrcToHead(url: string): void {
    const head = <HTMLDivElement>document.head;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = true;
    head.appendChild(script);
}

export function loadScriptToHead(text: string): void {
    const head = <HTMLDivElement>document.head;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.text = text;
    script.async = true;
    script.defer = true;
    head.appendChild(script);
}

export function loadScriptSrcAppendToBody(url: string): void {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = true;
    script.defer = true;
    body.appendChild(script);
}

function addDatadog(): void {
    const env = <string>environment.type;
    if (
        window.location.host.startsWith('pr-') ||
        window.location.host.startsWith('auto-develop') ||
        window.location.host.startsWith('localhost') ||
        window.location.host.startsWith('stage')
    ) {
        // const idx = window.location.host.indexOf('.');
        // env = window.location.host.substring(0, idx);
        return; // datadog request slow Cypress tests down
    }

    datadogRum.init({
        applicationId: 'b0f71b80-bd96-4b04-95a6-8eddc178e713',
        clientToken: 'pub0eef5ab2e292fe9cd02fc8f80e1cc509',
        site: 'datadoghq.eu',
        service: 'frontend',
        env,
        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackFrustrations: true,
        trackLongTasks: true,
        trackResources: true,
        trackUserInteractions: true,
        enableExperimentalFeatures: ['clickmap'],
        defaultPrivacyLevel: 'mask-user-input',
    });

    datadogRum.startSessionReplayRecording();
}
